import React from 'react';
import CatFilterItem from './CatFilterItem';
import { Button } from 'antd';

export default function CatFilterList({ catArray, selectedCatArray, updateFilter, clearFilter, isFilter }) {

  if (Array.isArray(catArray) && Array.isArray(selectedCatArray) && isFilter) {
    return (
      <ul className="filter-list filter-list-cat mb-2">
        {catArray.map((cat) => <CatFilterItem key={cat.id}
                                              category={cat}
                                              updateFilter={updateFilter}
                                              clearFilter={clearFilter}
                                              isSelected={selectedCatArray.includes(cat.id)}
        />)}
        <Button onClick={clearFilter()}>Clear All</Button>
      </ul>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/containers/Categories/components/CatFilterList/index.js